import React, { useState } from 'react';
import { Card, Spinner } from '../design-system';
import CardGrid from './CardGrid';
import CardDetailsModal from './CardDetailsModal';

// Hardcoded card data for proof of concept
const ALL_CARDS = [
  {
    cardId: 'card_1',
    name: 'Unlocked Card',
    description: 'You\'ve unlocked your first card!',
    imageUrl: '/images/mascot/mindfulwanderer.png',
    colorScheme: { primary: '#FFB84D', secondary: '#FF8C42' },
    motivationalMessage: 'You showed up for yourself today. That matters.'
  },
  {
    cardId: 'card_2',
    name: 'Card 2',
    description: 'Complete more tasks to unlock this card',
    imageUrl: '/images/mascot/unlockedcard.png',
    colorScheme: { primary: '#6B73FF', secondary: '#9B59B6' },
    motivationalMessage: 'Keep going!'
  },
  {
    cardId: 'card_3',
    name: 'Card 3',
    description: 'Complete more tasks to unlock this card',
    imageUrl: '/images/mascot/unlockedcard.png',
    colorScheme: { primary: '#FF6B9D', secondary: '#FFB3BA' },
    motivationalMessage: 'Keep going!'
  },
  {
    cardId: 'card_4',
    name: 'Card 4',
    description: 'Complete more tasks to unlock this card',
    imageUrl: '/images/mascot/unlockedcard.png',
    colorScheme: { primary: '#4ECDC4', secondary: '#44A08D' },
    motivationalMessage: 'Keep going!'
  },
  {
    cardId: 'card_5',
    name: 'Card 5',
    description: 'Complete more tasks to unlock this card',
    imageUrl: '/images/mascot/unlockedcard.png',
    colorScheme: { primary: '#FF6B6B', secondary: '#FF8E53' },
    motivationalMessage: 'Keep going!'
  }
];

// Hardcoded: Everyone has the first card collected
const COLLECTED_CARDS = ['card_1'];

const CardCollectionView = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const handleCardClick = (card) => {
    setSelectedCard(card);
    setShowDetails(true);
  };

  const collectedCount = COLLECTED_CARDS.length;
  const totalCards = ALL_CARDS.length;

  return (
    <div className="space-y-6">
      {/* Header with Progress */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">My Card Collection</h1>
          <p className="text-gray-600 mt-1">
            Collect cards by completing tasks!
          </p>
        </div>
        <div className="text-right">
          <div className="text-3xl font-bold text-primary">
            {collectedCount} / {totalCards}
          </div>
          <div className="text-sm text-gray-600">Cards Collected</div>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-3">
        <div 
          className="bg-primary h-3 rounded-full transition-all duration-300"
          style={{ width: `${(collectedCount / totalCards) * 100}%` }}
        />
      </div>

      {/* Card Grid */}
      <CardGrid
        allCards={ALL_CARDS}
        collectedCards={COLLECTED_CARDS}
        onCardClick={handleCardClick}
      />

      {/* Card Details Modal */}
      {showDetails && selectedCard && (
        <CardDetailsModal
          card={selectedCard}
          isCollected={COLLECTED_CARDS.includes(selectedCard.cardId)}
          onClose={() => {
            setShowDetails(false);
            setSelectedCard(null);
          }}
        />
      )}
    </div>
  );
};

export default CardCollectionView;

